import { configureStore } from '@reduxjs/toolkit'
import authReducer from './redux/AuthSlice'
import layoutReducer from './redux/LayoutSlice'

export default configureStore({
  reducer: {
    auth: authReducer,
    layout: layoutReducer
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})
